import entity from '../../../models/base/modules'

export default [
  {
    path: '/modules',
    meta: {
      entity,
      requiresPermissionTo: 'modules',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/modules/new',
    meta: {
      entity,
      requiresPermissionTo: 'modules',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/modules/:id',
    meta: {
      entity,
      requiresPermissionTo: 'modules',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
